"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M16 12 9 2 2 12h1.86L0 18h7v4h4v-4h7l-3.86-6z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20.14 12H22L15 2l-2.39 3.41L17.92 13h-1.95l3.22 5H24zM13 19h4v3h-4z"
}, "1")], 'ForestSharp');